import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const token = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : null

export const ratingApi = createApi({
    reducerPath: 'ratingApi',
    baseQuery: (fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin`, prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    endpoints: (build) => ({
        getRatings: build.query({
            query() {
                return {
                    url: '/ratings',
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Ratings']
        }),
        deleteRating: build.mutation({
            query(id) {
                return {
                    url: `/ratings/${id}`,
                    params: {},
                    method: 'DELETE',
                    headers: {}
                }
            },
            invalidatesTags: ['Ratings']
        }),
    })
});

export const { useGetRatingsQuery, useDeleteRatingMutation } = ratingApi;